import { TimeScaleType } from 'v2/models';

export interface CostField {
  time_period?: TimeScaleType;
  cost: {
    unit: string | number | null;
    value: string;
  };
}

export interface PurchaseField {
  id?: number;
  note?: string;
  purchase_date?: string;
  renewal_date?: string;
  opt_out_date?: string | null;
  timescale?: TimeScaleType;
  cost: {
    unit: string | number | null;
    value: string;
  };
}

export interface PurchaseForm {
  purchases: PurchaseField[];
}

export const SCALE_TIME_DATA_PRODUCT_PURCHASE: {
  [key: string]: TimeScaleType;
} = {
  PERPETUAL_LICENSE: 'perpetual_license',
  PER_YEAR: 'per_year',
  PER_QUARTER: 'per_quarter',
  PER_MONTH: 'per_month',
  CONSUMPTION_BASED: 'consumption_based',
};

export const SCALE_TIME_DATA_PRODUCT_PURCHASE_TEXT = {
  [SCALE_TIME_DATA_PRODUCT_PURCHASE.PERPETUAL_LICENSE]: 'Perpetual License',
  [SCALE_TIME_DATA_PRODUCT_PURCHASE.PER_YEAR]: 'Per Year',
  [SCALE_TIME_DATA_PRODUCT_PURCHASE.PER_QUARTER]: 'Per Quarter',
  [SCALE_TIME_DATA_PRODUCT_PURCHASE.PER_MONTH]: 'Per Month',
  [SCALE_TIME_DATA_PRODUCT_PURCHASE.CONSUMPTION_BASED]: 'Consumption Based',
};

export const getTimescaleText = (timescale: TimeScaleType) => {
  return SCALE_TIME_DATA_PRODUCT_PURCHASE_TEXT[timescale];
};

const formatting_options = {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
};
export const dollarString = new Intl.NumberFormat('en-US', formatting_options);

export const DATA_PRODUCT_COSTS_CURRENCIES = [
  'AUD',
  'CAD',
  'CHF',
  'CNY',
  'EUR',
  'GBP',
  'JPY',
  'SGD',
  'USD',
];

export function getCurrencyOptions() {
  const currencies = [...DATA_PRODUCT_COSTS_CURRENCIES] as string[];

  return currencies.map((currency) => ({
    label: currency,
    value: currency,
  }));
}

export function getTimeScaleOptions() {
  const timeScaleOptions = Object.entries(
    SCALE_TIME_DATA_PRODUCT_PURCHASE_TEXT
  ).map(([value, label]) => ({ value, label }));

  return [
    { label: 'Select one option', value: '', hidden: true },
    ...timeScaleOptions,
  ];
}
